﻿
window.addEventListener('load', () => {

    // switch desktop/mobile checkout

    function toggleCartLayout() {
        const cartSidebar = document.querySelector('.checkout-summary-content .cart-sidebar'); // cart list in sticky cart
        const checkoutContent = document.querySelector('.checkout-content'); // desktop cart 
        const checkoutSummaryContent = document.querySelector('.checkout-summary-content'); // sticky cart 

        if (cartSidebar && checkoutContent && checkoutSummaryContent) {

            if (!window.matchMedia("(max-width: 999px)").matches) {
                checkoutContent.appendChild(cartSidebar);
            }

            window.addEventListener('resize', () => {
                if (window.matchMedia("(max-width: 999px)").matches) {
                    checkoutSummaryContent.appendChild(cartSidebar);
                } else {
                    checkoutContent.appendChild(cartSidebar);
                }
            });

        }
    }

    // ----- checkout summary show-hide

    function toggleCheckoutSummary() {

        const checkoutSummaryHeader = document.querySelector('.checkout-summary-header');

        if (!checkoutSummaryHeader) {
            return;
        }

        checkoutSummaryHeader.addEventListener('click', () => {

            const toggle = checkoutSummaryHeader.querySelector('.checkout-summary-header-toggle');
            const content = checkoutSummaryHeader.nextElementSibling;

            if (content) {
                const willOpen = !content.classList.contains('visible');
                if (willOpen) {
                    const expandedHeight = Math.min(content.scrollHeight, window.innerHeight * 0.7);
                    content.style.setProperty('--checkout-summary-expanded-height', `${expandedHeight}px`);
                }
                content.classList.toggle('visible', willOpen);
            }

            if (toggle) {
                toggle.classList.toggle('content-visible');
            }
        });
    }

    toggleCartLayout()
    toggleCheckoutSummary();
});
